import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-data';

export interface IFpLoggerNoiseCommentsState {
  currentTab: FpLoggerNoiseTabs.Comments;
  date: string | null;
  data: IFpLoggerNoiseData | null;
  loading: boolean;
  saved: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialFpLoggerNoiseCommentsState: IFpLoggerNoiseCommentsState = {
  currentTab: FpLoggerNoiseTabs.Comments,
  date: null,
  data: null,
  loading: false,
  saved: false,
  error: null,
};
